module.exports = __webpack_public_path__ + "img/t20-cup-logo-colour.245aeb3f.png";